import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Popup } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import Util from "../Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tf,
  tfArray
} = I18N.ns('molten.views.userSettings.LoadFromSharedProfiles');
function ProfileRenderer({
  context,
  profiles,
  onClose,
  canSystem,
  dispatch
}) {
  const {
    editor
  } = context;
  useEffect(Util.getCanSystemEffect(dispatch, canSystem), []);
  if (!profiles?.length) {
    return null;
  }
  const load = ({
    data
  }) => {
    editor.onChange({
      value: data || {}
    });
    if (onClose) onClose();
  };
  return profiles?.map(v => /*#__PURE__*/_jsx(Popup.Item, {
    onClick: load,
    eventData: v.value,
    children: v.displayName
  }, v.name)) || null;
}
export default {
  id: 'molten.userSetting.titleLeft.loadFrom.sharedProfiles',
  name: tf('name'),
  matches: {
    use: 'titleLeft',
    client: 'UserSettingsEditor',
    managePersonas: true
  },
  handles: context => {
    return !context.simple;
  },
  layout: {
    group: ['loadFrom', 'sharedProfiles'],
    groupIcons: [() => {
      return Config.get('Main', 'loadIcon', 'fa fa-download fa-fw');
    }, null],
    groupNames: tfArray('groupNames'),
    sort: 'aaaa.aaaa'
  },
  customComponent: connect((state, props) => ({
    profiles: Util.getProfiles(state, props, {
      getValues: true,
      getProfileFn: 'getSharedProfile'
    }),
    canSystem: Util.getCanSystem(state, props)
  }))(ProfileRenderer)
};